export default __webpack_public_path__ + "8be315aade1acf0e57d5cc60271b3225.svg";